export default __webpack_public_path__ + "static/media/OctoMobile.7f583685.svg";